import React from 'react';
import { Search, X, MessageCircle } from 'lucide-react';

const SearchBar = ({
  value,
  onChange,
  onClear,
  onCompose,
  placeholder = 'Search',
  showComposeButton = true,
  composeLabel = 'Compose',
  composeShortLabel = 'New',
  className = ''
}) => {
  return (
    <div className={`flex gap-2 ${className}`}>
      {/* Search Input */}
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-white" size={16} />
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          data-testid="search-input"
          className="w-full pl-9 md:pl-10 pr-3 md:pr-4 py-2 md:py-2.5 bg-black border border-gray-400 rounded-lg text-xs md:text-sm text-white placeholder-white focus:outline-none focus:ring-2 focus:ring-gray-300 hover:bg-gray-900 transition-all"
        />
        {value && onClear && (
          <button
            onClick={onClear}
            data-testid="search-clear-btn"
            className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-white hover:text-gray-300"
          >
            <X size={14} />
          </button>
        )}
      </div>

      {/* Compose Button */}
      {showComposeButton && onCompose && (
        <button
          onClick={onCompose}
          data-testid="compose-btn"
          className="px-3 md:px-4 py-2 md:py-2.5 bg-white hover:bg-gray-200 rounded-lg transition-colors flex items-center gap-1 md:gap-2 text-black font-medium text-xs md:text-sm"
          title="Compose new message"
        >
          <MessageCircle size={16} />
          <span className="hidden sm:inline">{composeLabel}</span>
          <span className="sm:hidden">{composeShortLabel}</span>
        </button>
      )}
    </div>
  );
};

export default SearchBar;
